import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

//  This approach never worked for me.  Instead, to avoid messages about unsafe images, I used the following:
// 	import {DomSanitizer} from '@angular/platform-browser';
//
// 	editButtonPath;
//
// 	constructor(usersService: UsersService, confirmationService: ConfirmationService, private sanitization: DomSanitizer) {
// 		this.editButtonPath = this.sanitization.bypassSecurityTrustStyle('url(assets/images/EditIcon/Edit_Icon_32.png)');
//
//  2019-04-17 Now that isn't working either... revisit
//

@Pipe({
	name: 'safe'
})
export class SafePipe implements PipeTransform {

	constructor(protected sanitizer: DomSanitizer) {}

	public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
	switch (type) {
			case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
			case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
			case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
			case 'url': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
			case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
			default: throw new Error(`Invalid safe type specified: ${type}`);
		}
	}

}
